import React from "react";

export function SEO({ title, description, image }) {
  React.useEffect(() => {
    if (title) document.title = `${title} · TrendingNewCar`;
    const set = (name, value) => {
      if (!value) return;
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        if (name.startsWith("og:") || name.startsWith("twitter:")) el.setAttribute("property", name);
        else el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    set("description", description);
    set("og:title", title);
    set("og:description", description);
    set("og:image", image);
    set("twitter:card", "summary_large_image");
    set("twitter:title", title);
    set("twitter:description", description);
    set("twitter:image", image);

    // Self-referential canonical (path only, ignores query/hash) for basic
    // production SEO / duplicate-content protection.
    try {
      const href = `${window.location.origin}${window.location.pathname}`.replace(/\/$/, "") || window.location.origin;
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", href);
    } catch (e) { /* no-op */ }
  }, [title, description, image]);
  return null;
}

export function StructuredData({ data }) {
  return <script type="application/ld+json">{JSON.stringify(data)}</script>;
}
